// extracted by mini-css-extract-plugin
export default {"date":"ReviewsList_date__zHk+7","reviewHeader":"ReviewsList_reviewHeader__PwsxK","text":"ReviewsList_text__qIpeT","reviewPanel":"ReviewsList_reviewPanel__m7KNs"};